import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const StyledTitle = styled.div`
  margin-bottom: 18px;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.textTitle};
`

export const StyledPic = styled.img`
  width: 100%;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 17px;
  margin: 16px 0 30px;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: 0.2px;
  color: ${({ theme }) => theme.colors.textTitle};

  p {
    margin-bottom: 0;
  }

  ul {
    margin-bottom: 0;
    padding-left: 0;
    list-style: none;

    li {
      display: flex;
      gap: 10px;
      line-height: 24px;

      .tip {
        color: ${({ theme }) => theme.colors.primary};
        width: 100%;
        margin-right: 4px;
      }

      .feature-number {
        margin-left: 4px;
      }
    }
  }
`

export const StyledButton = styled.button`
  background: ${({ theme }) => theme.colors.primary};
  border-radius: 48px;
  border: none;
  outline: none;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #ffffff;
  padding: 12px 0;
  width: 100%;
  cursor: pointer;
`
